import { render } from "./App.vue?vue&type=template&id=2c15bcda"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/packs/components/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c15bcda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c15bcda', __exports__)) {
    api.reload('2c15bcda', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=2c15bcda", () => {
    api.rerender('2c15bcda', render)
  })

}


export default __exports__